/**
 * ResizeManager — single page-wide `resize` listener.
 *
 * Mirrors ScrollManager: front-end components subscribe here instead of
 * adding their own `window.addEventListener( 'resize', ... )`, so N components
 * on one page share a single native listener and a single rAF-batched
 * dispatch per frame.
 *
 * Exposed on `window.wombat.resizeManager` for the same reason as
 * ScrollManager — see that file's docblock.
 */
class ResizeManager {

	/**
	 * Attach the single page-wide resize listener.
	 */
	constructor() {

		this.listeners = new Set();
		this.rafId = null;
		window.addEventListener( 'resize', this.onResize, { passive: true } );

	}

	onResize = () => {

		if ( this.rafId ) {

			return;

		}

		this.rafId = window.requestAnimationFrame( () => {

			this.rafId = null;
			this.listeners.forEach( ( listener ) => listener() );

		} );

	};

	/**
	 * Subscribe to resize updates.
	 *
	 * @param {Function} callback Called (no args) on the next frame after a resize.
	 * @return {Function} Unsubscribe function.
	 */
	addListener = ( callback ) => {

		this.listeners.add( callback );

		return () => this.removeListener( callback );

	};

	removeListener = ( callback ) => {

		this.listeners.delete( callback );

	};

}

export default new ResizeManager();
